export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si vous annulez l'échange, il sera fermé sans terminer l'opération."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Êtes-vous sûr de vouloir annuler l'échange?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui, annuler"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non, garder actif"])}
}